export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_REQUEST_SUCCESS = 'CREATE_USER_REQUEST_SUCCESS';
export const CREATE_USER_REQUEST_ERROR = 'CREATE_USER_REQUEST_ERROR';

export const CREATE_PROFILE_REQUEST = 'CREATE_PROFILE_REQUEST';
export const CREATE_PROFILE_REQUEST_SUCCESS = 'CREATE_PROFILE_REQUEST_SUCCESS';
export const CREATE_PROFILE_REQUEST_ERROR = 'CREATE_PROFILE_REQUEST_ERROR';
